import styles from './MarketingConsentCardSection.module.css';
import { Switch } from '@blueprintjs/core';
import { classNames } from '@axo/shared/util/dom';
import {
  ConsentData,
  ConsentStateType,
} from '@axo/shared/data-access/types/consent';

export const ConsentSwitch = ({
  consentData,
  disabled,
  label,
  onChecked,
}: {
  consentData: ConsentData;
  disabled: boolean;
  /** Accessible name; the visible label sits above the switch. */
  label?: string;
  onChecked?: (consentData: ConsentData, value: boolean) => void;
}) => {
  return (
    <div className={styles.optOutSwitchWrapper}>
      <Switch
        className={classNames(styles.control, styles.optOutSwitch)}
        disabled={disabled}
        aria-label={label}
        style={{ marginBottom: 0 }}
        checked={consentData.State === ConsentStateType.Given}
        onChange={() => {
          const value = !(consentData.State === ConsentStateType.Given);
          if (onChecked) {
            onChecked(consentData, value);
          }
        }}
      />
    </div>
  );
};
